import WeatherIcon from '../WeatherIcon/WeatherIcon';

const WeeklyForecast = ({ weekData }) => {
    if (!weekData) return null;

    return (
        <div className='weekDiv roundBox'>
            {weekData.map((item, i) => {
                if (item.dayStr) {
                    return (
                        <div key={i + item.dayStr}>
                            <label>{item.dayStr}</label>
                            <label>{item.rainRate}<label className='topTxt'>%</label></label>
                            <WeatherIcon name={item.morning} size={28} />
                            <WeatherIcon name={item.afternoon} size={28} />
                            <label>{item.minTemp}<label className='topTxt'>o</label></label>
                            <label>{item.maxTemp}<label className='topTxt'>o</label></label>
                        </div>
                    );
                }
                return <div key={i}></div>;
            })}
        </div>
    );
};

export default WeeklyForecast;
